import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';

export default function ConnectionStatus() {
  const { isConnected } = useSocket();
  const { user } = useAuth();
  const location = useLocation();
  const [showStatus, setShowStatus] = useState(true);
  const isPrivateRoute =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/child');
  const shouldShowConnectionStatus = Boolean(user) && isPrivateRoute;

  useEffect(() => {
    if (!shouldShowConnectionStatus) {
      setShowStatus(false);
      return;
    }

    if (isConnected) {
      const timer = setTimeout(() => setShowStatus(false), 3000);
      return () => clearTimeout(timer);
    } else {
      setShowStatus(true);
    }
  }, [isConnected, shouldShowConnectionStatus]);

  // Show socket status only for authenticated users on private app routes.
  if (!shouldShowConnectionStatus) return null;

  if (!showStatus && isConnected) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        borderRadius: '8px',
        backgroundColor: isConnected ? '#10b981' : '#f87171',
        color: '#fff',
        fontSize: '13px',
        fontWeight: '600',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        animation: isConnected
          ? 'none'
          : 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      }}
    >
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#fff',
          animation: isConnected ? 'none' : 'pulse-dot 1.5s ease-in-out infinite',
        }}
      />
      {isConnected ? '🔌 Connected' : '⏳ Reconnecting...'}

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes pulse-dot {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
        }
      `}</style>
    </div>
  );
}
